import { ConversationParticipantEntity } from '@provision/conversation-types';
import { Dispatch, SetStateAction, useState } from 'react';
import { SidePanelTabs } from 'src/components';
import { Conversation } from 'src/graphql';
import { ConversationParticipants } from './ConversationParticipants/conversation-participants';
import { ConversationSites } from './ConversationSite/conversation-sites';

interface ConversationTabsProps {
  conversation: Conversation;
}

enum CurrentConversationTabs {
  Site = 'site',
  Participants = 'participants',
}

interface TabContentProps {
  conversation: Conversation;
  activeTab: CurrentConversationTabs;
  setActiveTab: Dispatch<SetStateAction<CurrentConversationTabs>>;
}

const TabContent = ({ activeTab, setActiveTab, conversation }: TabContentProps) => {
  if (activeTab === CurrentConversationTabs.Site) {
    return <ConversationSites conversation={conversation} />;
  }

  if (activeTab === CurrentConversationTabs.Participants) {
    return (
      <ConversationParticipants
        conversation={conversation}
        onSuccessSubmit={() => {
          setActiveTab(CurrentConversationTabs.Site);
        }}
      />
    );
  }

  return null;
};

const tabs = [
  {
    value: CurrentConversationTabs.Site,
    label: 'Site',
    icon: 'maps_home_work',
  },
  {
    value: CurrentConversationTabs.Participants,
    label: 'Participants',
    icon: 'people',
  },
];

export const ConversationTabs = ({ conversation }: ConversationTabsProps) => {
  const requesterEntity =
    conversation.requester?.participantEntity?.toLowerCase() as ConversationParticipantEntity;
  const isRequesterUnknown = requesterEntity === ConversationParticipantEntity.Unknown;
  const [activeTab, setActiveTab] = useState(
    isRequesterUnknown ? CurrentConversationTabs.Participants : CurrentConversationTabs.Site,
  );

  return (
    <SidePanelTabs
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      tabs={tabs}
      showLabel
      variant="fullWidth"
      isNested
    >
      <TabContent
        conversation={conversation}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
    </SidePanelTabs>
  );
};
